import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home'),
  },
  {
    path: '/scoreInquiry',
    name: 'scoreInquiry',
    component: () => import('@/views/home/scoreInquiry')
  },
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import('@/views/personal/personalCenter')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    redirect: '/home',
    children: [
      {
        path: '/exam-notice',
        name: 'exam-notice',
        component: () => import('@/views/home/examNotice')
      },
      {
        path: '/start-exam/:id',
        name: 'start-exam',
        component: () => import('@/views/home/startExam.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: constantRouterMap,

// 新增滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    // 处理浏览器前进/后退时的原生滚动位置
    if (savedPosition) {
      return savedPosition
    }
    // 新路由导航时始终滚动到顶部
    return { x: 0, y: 0 }
    // 如需平滑滚动效果可改为：
    // return { behavior: 'smooth', x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js